/* eslint-disable @typescript-eslint/camelcase */
import {
  ModelTypeEnum,
  EnvironmentFields,
  FormModelProps,
  ModelFormFields,
  ProviderDataFormModel,
} from 'modules/environments/interfaces';
import omit from 'lodash/omit';
import { ObjectSchema } from 'yup';

export function stripLicenseTypeFromModelPayload<
  T extends ModelFormFields | FormModelProps
>(values: T): T {
  if (!values.provider_data) return values;
  return {
    ...values,
    provider_data: omit(
      values.provider_data,
      'license_type'
    ) as ProviderDataFormModel,
  };
}

export const getFlavorsType = (type = ModelTypeEnum.customImage) =>
  ({
    [ModelTypeEnum.bootVolume]: 'bootVolumeFlavors',
    [ModelTypeEnum.bootVolumeBackup]: 'bootVolumeBackupFlavors',
    [ModelTypeEnum.customImage]: 'customImageFlavors',
  }[type]);

export const getModelTypeByPublicationType = (
  type = ModelTypeEnum.customImage
) =>
  ({
    [ModelTypeEnum.customImage]: 'images',
    [ModelTypeEnum.bootVolume]: 'bootVolumes',
    [ModelTypeEnum.bootVolumeBackup]: 'bootVolumeBackups',
  }[type]);

export const getProviderFieldByPublicationType = (
  modelSelected: ModelFormFields | null
) => (type = ModelTypeEnum.customImage) =>
  ({
    [ModelTypeEnum.customImage]: {
      key: 'images',
      value: modelSelected?.provider_data?.image_id,
    },
    [ModelTypeEnum.bootVolume]: {
      key: 'bootVolume',
      value: modelSelected?.provider_data?.boot_volume_id,
    },
    [ModelTypeEnum.bootVolumeBackup]: {
      key: 'bootVolumeBackup',
      value: modelSelected?.provider_data?.boot_volume_backup_id,
    },
  }[type]);

export const getSchemaByProviderAndSchema = (
  cloudProvider: string,
  validationSchema: Record<string, ObjectSchema<any>>
) => (type = ModelTypeEnum.customImage) =>
  ({
    [ModelTypeEnum.customImage]: validationSchema[cloudProvider],
    [ModelTypeEnum.bootVolume]: validationSchema.ociBootVolume,
    [ModelTypeEnum.bootVolumeBackup]: validationSchema.ociBootVolumeBackup,
  }[type]);

export const getOnSubmitByProvider = (
  environment: EnvironmentFields | null,
  onSubmit
) => (type = ModelTypeEnum.customImage) =>
  ({
    [ModelTypeEnum.bootVolume]: (values: ModelFormFields | FormModelProps) =>
      onSubmit({
        values: {
          ...values,
          provider_data: {
            ...values.provider_data,
            boot_volume_id: values?.provider_data?.boot_volume_id,
            region: environment?.provider?.region,
          },
        },
        pathUrl: 'oci/boot-volume/',
      }),
    [ModelTypeEnum.bootVolumeBackup]: (
      values: ModelFormFields | FormModelProps
    ) =>
      onSubmit({
        values: {
          ...values,
          provider_data: {
            ...values?.provider_data,
            boot_volume_backup_id: values?.provider_data?.boot_volume_backup_id,
            region: environment?.provider?.region,
          },
        },
        pathUrl: 'oci/boot-volume-backup/',
      }),
    [ModelTypeEnum.customImage]: (values: ModelFormFields | FormModelProps) =>
      onSubmit({
        values: {
          ...values,
          provider_data: {
            ...values?.provider_data,
            image_id: values?.provider_data?.image_id,
            region: environment?.provider?.region,
          },
        },
        pathUrl: 'oci/image/',
      }),
  }[type]);

export const getFieldStateKeyByProvider = (type: ModelTypeEnum) =>
  ({
    [ModelTypeEnum.customImage]: 'provider_data.image_id',
    [ModelTypeEnum.bootVolume]: 'provider_data.boot_volume_id',
    [ModelTypeEnum.bootVolumeBackup]: 'provider_data.boot_volume_backup_id',
  }[type]);

export const getFieldKeyByProvider = (type: ModelTypeEnum) =>
  ({
    [ModelTypeEnum.customImage]: 'image_id',
    [ModelTypeEnum.bootVolume]: 'boot_volume_id',
    [ModelTypeEnum.bootVolumeBackup]: 'boot_volume_backup_id',
  }[type]);
